import React from "react";
import { Table } from "antd";

const columns = [
  {
    title: "ชื่อหนังสือ",
    dataIndex: "name",
  },
  {
    title: "ราคา/เล่ม",
    dataIndex: "price",
  },
  {
    title: "ค่าสมาชิก/ปี(รวมค่าส่ง)",
    dataIndex: "fee",
    render: (feeText) => {
      const feeLines = feeText.split("\n");
      return (
        <>
          {feeLines.map((line) => (
            <div key={line} style={{ display: "block" }}>
              {line}
            </div>
          ))}
        </>
      );
    },
  },
];

const data = [
  {
    name: "หนังสือพลังประจำวัน",
    price: "60 บาท/เล่ม",
    fee: "200 บาท/ปี (4 เล่ม)\n 550 บาท/3 ปี (12 เล่ม)\n  1,000 บาท/6 ปี (24 เล่ม)",
  },
  {
    name: "Daily Bread",
    price: "200 บาท/เล่ม",
    fee: "800 บาท/ปี (4 เล่ม)",
  },
  {
    name: "Encounter with God",
    price: "200 บาท/เล่ม",
    fee: "800 บาท/ปี (4 เล่ม)",
  },
  {
    name: "หนังสือพลังประจำวัน",
    price: "200 บาท/เล่ม",
    fee: "800 บาท/ปี (4 เล่ม)",
  },
];

const NormalTable = () => {
  return (
    <>
      <Table columns={columns} dataSource={data} pagination={false} bordered />
    </>
  );
};

export default NormalTable;
